export var SettingTarget;
(function (SettingTarget) {
    SettingTarget["CONFIG_BOOTSTRAP"] = "ConfigBootstrap";
    SettingTarget["DATA_CACHE"] = "DataCache";
    SettingTarget["FS_CONFIG"] = "FilespaceConfig";
    SettingTarget["FS_INIT"] = "FilespaceInit";
    SettingTarget["FILE_SYSTEM"] = "FileSystem";
    SettingTarget["WEB_SERVICE"] = "WebService";
    SettingTarget["SNAPSHOT_SCHEDULER"] = "SnapshotScheduler";
    SettingTarget["FILE_STORE"] = "FileStore";
    SettingTarget["AUDIT"] = "Audit";
    SettingTarget["OBJECT_SCHEDULER"] = "ObjectScheduler";
    SettingTarget["STS"] = "Sts";
    SettingTarget["STS_SETTING"] = "StsSetting";
})(SettingTarget || (SettingTarget = {}));
export var SettingName;
(function (SettingName) {
    SettingName["OBJECT_STORE_CREDENTIALS_TYPE"] = "objectStoreCredentialsType";
    SettingName["OBJECT_STORE"] = "objectStore";
    SettingName["ACCESS_TOKEN_CONFIG"] = "accessTokenConfig";
    SettingName["STS_CREDENTIALS"] = "Credentials";
    SettingName["BUCKET_NAME"] = "bucketName";
    SettingName["OBJECT_PREFIX"] = "objectPrefix";
    SettingName["ENDPOINT"] = "endpoint";
    SettingName["LOCATION_CONSTRAINT"] = "locationConstraint";
    SettingName["VIRTUAL_ADDRESSING"] = "virtualAddressing";
    SettingName["PROTOCOL"] = "protocol";
    SettingName["REGION"] = "region";
    SettingName["PROVIDER"] = "provider";
    SettingName["BLOCK_SIZE"] = "blockSize";
    SettingName["STORAGE_CLASS"] = "storageClass";
    SettingName["OBJECT_STORE_STS_ROLE_CONFIG"] = "objectStoreStsRoleConfig";
    SettingName["FS_VERSION"] = "filespaceVersion";
    SettingName["ENCRYPT_MODE"] = "encryptionMode";
    SettingName["FS_NAME"] = "fileSystemName";
    SettingName["ACCESS_KEY_ID"] = "accessKeyId";
    SettingName["SECRET_KEY"] = "secretKey";
    SettingName["SERVER_RSA_PUBLIC"] = "serverRSAPublic";
    SettingName["SERVER_ACCESS_KEY_ID"] = "serverAccessKeyId";
    SettingName["SERVER_SECRET_KEY"] = "serverSecretKey";
    SettingName["COMMON_CONFIG_KEY"] = "commonConfigKey";
    SettingName["SERVER_COMMON_CONFIG_KEY"] = "serverCommonConfigKey";
    SettingName["DEFAULT_MOUNT_POINT_SCHEME"] = "DefaultMountPointScheme";
    SettingName["FORBID_SPECIAL_CHARACTERS"] = "ForbidSpecialCharacters";
    SettingName["MULTI_LOGIN_ENABLED"] = "MultiLoginEnabled";
    SettingName["EXTERNAL_FILES_ENABLED"] = "ExternalFilesEnabled";
    SettingName["WEB_SERVICE_URL"] = "Url";
    SettingName["DEFAULT_SNAPSHOT_SCHEDULES_STATE"] = "DefaultSchedulesState";
    SettingName["FS_SIZE_LIMIT"] = "MaxFsSize";
    SettingName["FS_ENTRIES_LIMIT"] = "MaxFsEntries";
    SettingName["FS_STORAGE_SIZE_LIMIT"] = "MaxStorageSize";
    SettingName["FS_EXTERNAL_FILES_SIZE_LIMIT"] = "MaxExternalFilesSize";
    SettingName["FS_EXTERNAL_FILES_COUNT_LIMIT"] = "MaxExternalFilesCount";
    SettingName["ON_OPEN_LOCKING_EXTENSIONS"] = "LockingExtensions";
    SettingName["MOUNT_POINT_OSX"] = "MountPointOSX";
    SettingName["MOUNT_POINT_WINDOWS"] = "MountPointWindows";
    SettingName["MOUNT_POINT_LINUX"] = "MountPointLinux";
    SettingName["DATA_CACHE_SIZE"] = "Size";
    SettingName["STUCK_STATE_INTERVAL_SETTING"] = "StuckStateInterval";
    SettingName["FEATURE_ENABLED"] = "FeatureEnabled";
    SettingName["MAX_DOWNLOAD_RATE"] = "MaxDownloadRate";
    SettingName["MAX_UPLOAD_RATE"] = "MaxUploadRate";
    SettingName["FS_ACCESS_MODE"] = "FileSystemAccessMode";
    SettingName["FS_EVENTS"] = "FsEvents";
    SettingName["STS_REFRESH_INTERVAL"] = "RefreshInterval";
    SettingName["LOST_AND_FOUND_CRYPTO_KEY"] = "LostAndFoundDirCryptoKey";
    SettingName["FILESPACE_ADMIN_PUBLIC_KEY"] = "FilespaceAdminPublicKey";
})(SettingName || (SettingName = {}));
